import { setSuggestionPills } from '../actions/internalActions';
import { getStore } from '../store/store';
import { ObservableMap } from 'mobx';
import { mutator } from 'satcheljs';
export { ObservableMap };
export default mutator(setSuggestionPills, function (actionMessage) {
    getStore().suggestionPills = actionMessage.suggestionPills;
});
//# sourceMappingURL=setSuggestionPillsMutator.js.map